const SUPPORTED = ["fr", "en", "es", "pt"];
export const LANG_KEY = "yalola.lang";

const norm = (l) => {
  const c = (l || "").toLowerCase().slice(0, 2);
  return SUPPORTED.includes(c) ? c : null;
};

// One rule for every successful auth (login, OTP step-up, WhatsApp, register, /auth/me):
// the language chosen ON THIS DEVICE wins and is pushed to the account (Settings promises
// « ton choix est enregistré sur ton compte »); with no local choice the device adopts the
// account language. Keeps notifications (rendered in the ACCOUNT language) in sync with the UI.
export const decideLangSync = (storedLang, profileLang) => {
  const stored = norm(storedLang);
  const profile = norm(profileLang);
  if (stored) return stored !== profile ? { action: "push", lang: stored } : { action: "none", lang: stored };
  if (profile) return { action: "adopt", lang: profile };
  return { action: "none", lang: null };
};
